import { Component, EventEmitter, Input, Output } from '@angular/core'
import { FormControl, ReactiveFormsModule } from '@angular/forms'
import { I18nDirective } from 'app/shared/directives/app-i18n.directive'
import { InputValidationDirective } from 'app/shared/directives/input-validation.directive'
import { FormFloatingComponent } from 'app/shared/form/form-floating/form-floating.component'
import { CountryCodePipe } from '../../../pipes/country-code.pipe'

@Component({
    selector: 'form-address-country',
    template: `
        <form-floating>
            <label i18n="@@addressDetails_country_label" app-i18n="addressDetails_country_label">Land *</label>
            <select [formControl]="formCountry" (change)="selectChange.emit($event)" class="form-select" data-cy="country" input-validation>
                @for (country of orderworkTemplate?.country?.whitelist; track $index) {
                <option [ngValue]="country.toLowerCase()">
                    {{ country | countryCode }}
                </option>
                } @empty {
                <option value="nl" i18n="@@addressDetails_country_netherlands" app-i18n="addressDetails_country_netherlands">
                    Nederland
                </option>
                }
            </select>
        </form-floating>
    `,
    imports: [FormFloatingComponent, InputValidationDirective, ReactiveFormsModule, I18nDirective, CountryCodePipe],
})
export class FormAddressCountryComponent {
    @Input({ required: true }) formCountry: FormControl
    @Input({ required: true }) orderworkTemplate
    @Output() selectChange = new EventEmitter<Event>()
}
